import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const SettingsCtx = createContext(null);

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState(null);
  const load = useCallback(async () => {
    try { const { data } = await api.get("/settings/public"); setSettings(data); } catch { setSettings({}); }
  }, []);
  useEffect(() => { load(); }, [load]);
  return <SettingsCtx.Provider value={{ settings: settings || {}, reload: load }}>{children}</SettingsCtx.Provider>;
}

export function useSettings() { return useContext(SettingsCtx); }
